import { render, staticRenderFns } from "./ContactWithoutCallingDetails.vue?vue&type=template&id=ed534542&"
import script from "./ContactWithoutCallingDetails.vue?vue&type=script&lang=js&"
export * from "./ContactWithoutCallingDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports